module.exports = __webpack_public_path__ + "img/noa_burnette_5.0459058e.jpg";